import { FormattedMessage } from 'react-intl';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { yellow } from '@mui/material/colors';

import { useTheme } from '@mui/material';
import messages from './messages';

export const InactivityWarningCard = () => {
  const theme = useTheme();
  return (
    <Paper
      style={{
        backgroundColor: yellow[100],
        borderLeftStyle: 'solid',
        borderLeftWidth: 2,
        borderLeftColor: yellow[500],
        padding: theme.spacing(2),
      }}
    >
      <Typography>
        <FormattedMessage {...messages.inactivityWarning} />
      </Typography>
    </Paper>
  );
};

export default InactivityWarningCard;
